import React, { useState } from 'react';
import { useSearchParams } from "react-router-dom";

import { loginRequest/*, msalConfig*/ } from './office365auth/authConfig';
import { callMsGraph } from './office365auth/graph';

import { useMsal } from '@azure/msal-react';
import { Typography } from '@mui/material'
import Button from "react-bootstrap/Button";

import { SignOutButton } from './office365auth/SignOutButton';
import { useEffect } from 'react';
import Activacion from './Activacion';
import Requisitos from './Requisitos';

import { createAPIEndpoint } from '../api/index'
import { getConfiguration, ENDPOINTS } from '../api/config'
import { withPublicUrl } from '../helper/publicUrl'
import Modal from 'react-bootstrap/Modal';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

//import warningIcon from '../img/alerta.svg';
import errorIcon from '../img/negativo.svg';

import SeleccionHorario from './SeleccionHorario';
import SeleccionarPlanAcademico from './SeleccionPlanAcademico';
import ErrorModal, { useErrorHandling } from './ErrorModal';
import Spinner from './Spinner';
import Plantilla from './plantillas/Plantilla'
import SiguientesPasos from './SiguientesPasos';

import { populateStudentMetadata, saveMsToken, getMsToken } from '../helper/studentMetadata';
import { setProgress } from './Progreso';
import { getPlanesAcademicos } from './SeleccionPlanAcademico';
import { isUserFromApp } from '../api/index';

export default function Home() {

    const flowSteps = {
        home: 0,
        activacion: 1,
        requisitos: 2,
        seleccionHorario: 3,
        siguientesPasos: 4,
    };
    const [searchParams, setSearchParams] = useSearchParams();

    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);
    const [studentId, setStudentId] = useState(null);
    const [studentInfo, setStudentInfo] = useState(null);
    const [stepIndex, setStepIndex] = useState(flowSteps.home);

    const [noCandidatoModalShow, setNoCandidatoModalShow] = useState(false);
    const [noCandidatoModalMessage, setNoCandidatoModalMessage] = useState('');

    const [selectedPlan, setSelectedPlan] = useState(null);

    const { error, clearError, showErrorModal } = useErrorHandling('PA001');

    const [showSpinner, setShowSpinner] = useState(false);

    const getPlanData = (planId) => {
        if (!studentInfo) return null;
        return studentInfo.filter((x) => x.planacademico === planId)[0];
    };

    useEffect(() => {
        populateStudentMetadata(studentInfo, selectedPlan);
    }, [studentInfo, selectedPlan]);

    function RequestProfileData() {

        if (isUserFromApp()) {
            createAPIEndpoint(ENDPOINTS.getMe)
                .fetch()
                .then(res => {
                    setGraphData(res.data);
                })
                .catch(err => {
                    if (err.response.status === 401) {
                        saveMsToken(null);
                        window.location = withPublicUrl('/');
                        return;
                    }

                    showErrorModal(null, error.serie, '001');
                })
                .finally(() => {
                    setStudentInfo([]);
                    setShowSpinner(false);
                });

            return;
        }

        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance
            .acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
            })
            .then((response) => {
                saveMsToken(response.accessToken);
                callMsGraph(response.accessToken).then((response) => setGraphData(response));
            });
    }

    function ProcessFlow() {
        const handleOnContinue = (planAcademico) => setTimeout(() => {
            if (stepIndex === flowSteps.home && planAcademico) {
                SetStatusFromPlanAcademico(getPlanData(planAcademico));
            }
            setSelectedPlan(planAcademico)
        }, 0);
        const handleOnSelectAnotherPlan = () => setTimeout(() => setSelectedPlan(null), 0);
        const handleOnActivation = (planAcademico) => {
            setStepIndex(flowSteps.home);
            GetStudentInfo(studentId, null);
        };
        const handleOnContinueToSeleccionHorarios = () => { setStepIndex(flowSteps.seleccionHorario); };
        const handleSetProgress = (percentage, label) => { setTimeout(() => { setProgress(percentage, label); }, 10) };

        if (selectedPlan == null) {
            return <SeleccionarPlanAcademico studentInfo={studentInfo} onContinuar={handleOnContinue} />
        }

        if (stepIndex === flowSteps.home) //Home 
        {
            handleSetProgress(0, '');
            return (<>
                <Contenedor>
                    <NoCandidato open={noCandidatoModalShow} onClose={() => setNoCandidatoModalShow(false)} message={noCandidatoModalMessage} />
                </Contenedor>
            </>);
        }
        if (stepIndex === flowSteps.activacion) //Activacion 
        {
            let planesActivos = getPlanesAcademicos(studentInfo);
            if (!planesActivos) planesActivos = [];

            handleSetProgress(25, 'Confirma tu activación');
            return <Activacion
                planAcademico={getPlanData(selectedPlan)}
                onSelectAnotherPlan={handleOnSelectAnotherPlan}
                onActivation={handleOnActivation}
                showSelectAnotherPlan={planesActivos.length > 1}
            />
        }
        if (stepIndex === flowSteps.requisitos) //Requisitos
        {
            //handleSetProgress(50, 'Validación de requisitos');
            return <Requisitos planAcademico={getPlanData(selectedPlan)}
                onSiguiente={handleOnContinueToSeleccionHorarios}
                onUpdateStudentInfo={(studentInfo) => { setStudentInfo(studentInfo) }}></Requisitos>
        }
        if (stepIndex === flowSteps.seleccionHorario) //SeleccionHorario
        {
            //handleSetProgress(75, 'Confirmación de horario');
            return <SeleccionHorario planAcademico={getPlanData(selectedPlan)} onSiguiente={handleOnContinueToSeleccionHorarios}></SeleccionHorario>
        }
        if (stepIndex === flowSteps.siguientesPasos) //SiguientesPasos
        {
            handleSetProgress(100, 'Inscripción finalizada');
            return <SiguientesPasos planAcademico={getPlanData(selectedPlan)} onSiguiente={handleOnContinueToSeleccionHorarios}></SiguientesPasos>
        }
        return null;
    }

    function getMatricula(email) {
        const regex = /E(\d+)/i;
        const match = email.match(regex);
        return match ? match[1] : null;
    }

    useEffect(() => {
        RequestProfileData();
    }, []);

    useEffect(() => {
        if (!graphData) return;
        let matricula = getMatricula(graphData.userPrincipalName);

        if (getConfiguration().enableOverrideStudentId) {
            if (searchParams.get("mat"))
                matricula = searchParams.get("mat");
        } else {
            if (searchParams.get("mat")) {
                window.location = withPublicUrl('/');
            }
        }

        setStudentId(matricula)
        //setStudentId(getMatricula('E00000407351@asddas.com'))
    }, [graphData]);

    useEffect(() => {
        if (!studentId) return;
        GetStudentInfo(studentId, null);
    }, [studentId]);

    const SetStatusFromPlanAcademico = (planAcademico) => {

        const estado = planAcademico.estado;

        // Matricula no encontrada o error en el servicio
        if (estado.valor === 1) {
            setNoCandidatoModalMessage(estado.mensajeportal)
            setNoCandidatoModalShow(true)
            setStepIndex(flowSteps.home);
            return;
        }

        // Matricula lista para activacion
        if (estado.valor === 2) {
            setStepIndex(flowSteps.activacion);
            return;
        }

        // Matricula con requisitos pendientes
        if (estado.valor === 4 || estado.valor === 5) {
            setStepIndex(flowSteps.requisitos);
            return;
        }

        // Matricula inscrita correctamente
        if (estado.valor === 6 || estado.valor === 7) {
            setStepIndex(flowSteps.siguientesPasos);
            return;
        }

        if (estado.valor === 0 || estado.valor === 3) {
            showErrorModal(null, estado.serie, estado.numero);
            return;
        }
    };


    function GetStudentInfo(matricula, planAcademico) {
        setShowSpinner(true);

        createAPIEndpoint(ENDPOINTS.getInformation)
            .fetchById(matricula)
            .then(res => {
                setStudentInfo(res.data);
                SetStatusFromPlanAcademico(res.data[0]);
            })
            .catch(err => {
                showErrorModal(null, error.serie, '001');
            })
            .finally(() => {
                setShowSpinner(false);
            });
    }

    const Contenedor = (props) => {
        return (
            <Container className="mb-3">
                <Row>
                    <Col>
                        {props.children}
                    </Col>
                </Row>
            </Container>
        );
    };

    return (<>
        <Spinner show={showSpinner} />
        <ProcessFlow />
        <ErrorModal error={error} onClose={clearError} />
    </>)
};

const NoCandidato = (props) => {
    if (!props.open) return null;

    return (<>
        <Plantilla id="NoCandidato"></Plantilla>

        <Row>
            <Col className="d-grid gap-2 mt-4">
                <SignOutButton />
            </Col>
        </Row>

    </>);
};

